import i18next from 'i18next';

import en from './i18n/en';
import es from './i18n/es';
import BigBookmarkOutlinedIcon from '../../components/icons/svg/BigBookmarkOutlinedIcon';
import BriefcaseVerifiedIcon from '../../components/icons/svg/BriefcaseVerifiedIcon';
import HomeIcon from '../../components/icons/svg/HomeIcon';
import MessageQuestionIcon from '../../components/icons/svg/MessageQuestionIcon';
import MousePencilIcon from '../../components/icons/svg/MousePencilIcon';
import PencilRulerIcon from '../../components/icons/svg/PencilRulerIcon';
import { INavItemProps } from '../../components/template-minimal/NavItem/NavItem';
import { FeaturesEnum } from '../../constants/enums/FeaturesEnum';
import { IFeatures } from '../../contexts/reducer/featureFlagsReducer';
import { PATH_DASHBOARD_STUDENT } from '../../routes/paths';
import { isVisualFeatureEnabled } from '../../utils/featureFlags';

i18next.addResourceBundle('en', 'LearnerSidebar', en);
i18next.addResourceBundle('es', 'LearnerSidebar', es);

const sidebarConfig = (features: IFeatures): ISideBarPathConfig[] => {
  const home = { title: 'HOME', path: PATH_DASHBOARD_STUDENT.admin.pageHome, icon: <HomeIcon /> };
  const skills = { title: 'SKILLS', path: PATH_DASHBOARD_STUDENT.admin.skills, icon: <PencilRulerIcon /> };
  const occupations = {
    title: 'OCCUPATIONS',
    path: PATH_DASHBOARD_STUDENT.admin.occupations,
    icon: <BriefcaseVerifiedIcon />,
  };
  const learningPathways = {
    title: 'LEARNING_PATHS',
    path: PATH_DASHBOARD_STUDENT.admin.LearningPaths,
    icon: <MousePencilIcon />,
  };
  const courses = { title: 'COURSES', path: PATH_DASHBOARD_STUDENT.admin.courses, icon: <BigBookmarkOutlinedIcon /> };
  const helps = { title: 'HELP', path: PATH_DASHBOARD_STUDENT.admin.help, icon: <MessageQuestionIcon /> };
  const paths: ISideBarPathConfig[] = [
    {
      items: [home, skills, occupations, courses, helps],
    },
  ];

  if (isVisualFeatureEnabled(features.qsemVisualFeatures, FeaturesEnum.qsemLearnerShowLearningPathways)) {
    paths[0].items.splice(3, 0, learningPathways);
  }

  return paths;
};

export interface ISideBarPathConfig {
  items: INavItemProps[];
}

export default sidebarConfig;
